var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypcnArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.9016 20.0001L29.1666 20.0001C29.496 19.9995 29.8179 19.9015 30.0916 19.7184C30.3654 19.5352 30.5788 19.2752 30.705 18.9709C30.8312 18.6667 30.8645 18.3319 30.8007 18.0087C30.7369 17.6856 30.5789 17.3886 30.3466 17.1551L20 6.66675L9.65498 17.1551C9.49967 17.3095 9.37642 17.4931 9.29232 17.6953C9.20822 17.8975 9.16492 18.1144 9.16492 18.3334C9.16492 18.5524 9.20822 18.7693 9.29232 18.9715C9.37642 19.1737 9.49967 19.3573 9.65498 19.5117C9.96747 19.8243 10.3913 20 10.8333 20.0001L14.9816 20.0001C14.8683 24.5834 14.0383 29.5917 8.33331 33.3334L9.99998 33.3334C17.7216 33.3334 24.0716 27.5001 24.9016 20.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypcnArrowBack);
export default __webpack_public_path__ + "static/media/typcn_arrow-back.d0d3af1b8b8651b8114fec52afee6cc6.svg";
export { ForwardRef as ReactComponent };